import { useState } from 'react';
import * as Api from '../../../../api/Api';
import { Unauthorized } from '../../../Global/unauthorized';
import PermissionsGate from '../../../../../app/api/PermissionsGate';
import { SCOPES } from '../../../../../app/config/permissions-map';
import { PageTitle } from '../../../../../_metronic/layout/core'
import EditCategoria from './EditCategoria';
import DeleteCategoria from './DeleteCategoria';
import AddCategoria from './AddCategoria';
import { useGetToken } from '../../../../Hooks/CustomHooks';
import AgTable from '../../../../Components/Table/AgTable';
import "./gestionCategorias.css";

export default function MapaAllIn_gestionCategorias({ title }) {
    const [showAddCategoria, setShowAddCategoria] = useState(false);
    const [showEditCategoria, setShowEditCategoria] = useState(false);

    const [refreshTable, setRefreshTable] = useState(true);

    const [categoriaEdit, setCategoriaEdit] = useState({});

    const [showRemoveCategoria, setShowRemoveCategoria] = useState(false);
    const [categoriaRemove, setCategoriaRemove] = useState({});

    let token = useGetToken();



    let header = [
        {
            headerName: 'Nombre',
            field: 'label'
        },
        {
            headerName: 'Verde',
            headerClass: 'headerVerde',
            children: [
                {
                    headerName: 'Desde',
                    field: 'semaforo.verde.desde',
                    cellRenderer: (props) => (
                        <span>{props.data.semaforo.verde.desde}%</span>
                    )
                },
                {
                    headerName: 'Hasta',
                    field: 'semaforo.verde.hasta',
                    cellRenderer: (props) => (
                        <span>{props.data.semaforo.verde.hasta}%</span>
                    )
                }
            ]
        },
        {
            headerName: 'Amarillo',
            headerClass: 'text-center headerAmarrillo',
            children: [
                {
                    headerName: 'Desde',
                    field: 'semaforo.amarillo.desde',
                    cellRenderer: (props) => (
                        <span>{props.data.semaforo.amarillo.desde}%</span>
                    )
                },
                {
                    headerName: 'Hasta',
                    field: 'semaforo.amarillo.hasta',
                    cellRenderer: (props) => (
                        <span>{props.data.semaforo.amarillo.hasta}%</span>
                    )
                }
            ]
        },
        {
            headerName: 'Rojo',
            headerClass: 'text-center headerRojo',
            children: [
                {
                    headerName: 'Desde',
                    field: 'semaforo.rojo.desde',
                    cellRenderer: (props) => (
                        <span>{props.data.semaforo.rojo.desde}%</span>
                    )
                },
                {
                    headerName: 'Hasta',
                    field: 'semaforo.rojo.hasta',
                    cellRenderer: (props) => (
                        <span>{props.data.semaforo.rojo.hasta}%</span>
                    )
                }
            ]
        },
        {
            headerName: 'Editar',
            cellRenderer: (props) => (
                <button onClick={() => {
                    setCategoriaEdit(props.data);
                    setShowEditCategoria(true);
                }} className="btn btn-light btn-active-light-primary btn-sm">
                    <i className="fi-rr-edit"></i>
                </button>
            )
        },
        {
            headerName: 'Eliminar',
            cellRenderer: (props) => (
                props.data.label === 'Todos' ? (
                    ''
                ) : (
                    <button onClick={() => {
                        setCategoriaRemove(props.data);
                        setShowRemoveCategoria(true);
                    }} className="btn bg-danger-mall btn-sm">
                        <i className="fi-rr-trash text-red-mall"></i>
                    </button>
                )
            )
        }
    ];

    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.MAPA_CALOR_ALL_IN]} >
                <PageTitle>{title}</PageTitle>

                <div className="card my-5">

                    <div className="card-body tab-content pt-0">
                        <div className="d-flex justify-content-end border-0 pt-6 mb-3">

                            <button className="btn bg-light-blue btn-sm" onClick={() => { setShowAddCategoria(true) }}><span className="text-blue fw-bold ">
                                <i className="fs-7 fi-rr-plus text-blue fw-bold "></i>
                                Añadir Categoría</span>
                            </button>
                            <DeleteCategoria categoriaDelete={categoriaRemove} showDeleteCategoria={showRemoveCategoria} setShowDeleteCategoria={setShowRemoveCategoria} setRefreshData={setRefreshTable}></DeleteCategoria>
                            <AddCategoria setShowAddCategoria={setShowAddCategoria} showAddCategoria={showAddCategoria} setRefreshData={setRefreshTable} />
                            <EditCategoria currentCategory={categoriaEdit} setShowEditCategoria={setShowEditCategoria} showEditCategoria={showEditCategoria} setRefreshData={setRefreshTable} />
                        </div>
                        <div className='table-responsive'>
                            <AgTable
                                idContent="usersTable"
                                apiService={Api.MapaCalorAllIn_CategoryList}
                                setAuxData={null}
                                header={header}
                                titleExcel={"Lista de Estado Cuenta"}
                                conditions={refreshTable}
                                args={{ type: 'table', token: token }}
                                hideFilter={false}
                                paginationPageSize={8}
                                rowHeight={40}
                                isDownload={false}
                                useFlex={false}
                            />
                        </div>
                    </div>
                </div>

            </PermissionsGate>
        </>
    )
}